import { render, staticRenderFns } from "./IndexPolizaLog.vue?vue&type=template&id=cb95d53a"
import script from "./IndexPolizaLog.vue?vue&type=script&lang=js"
export * from "./IndexPolizaLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports